import _ from 'lodash'

import actions from 'actions'

const defaultState = {
  currentPartnerId: null,
  identity: null,
  portalUserSearchResults: [],
  staticUrl: null,
  timezone: null,
}

export default function settings(state = defaultState, action) {
  switch (action.type) {
    case actions.ENTITIES_SETTINGS.SUCCESS:
      // Update the settings including identity and staticUrl
      return _.merge({}, state, action.response)
    case actions.SETTINGS_SET_CURRENT_PARTNER_ID:
      // Update the current partner ID
      return { ...state, currentPartnerId: action.partnerId }
    case actions.SETTINGS_PORTAL_USER_SEARCH_RESULTS.SUCCESS:
      return { ...state, portalUserSearchResults: action.response }
    case actions.SETTINGS_PARTNER_SEARCH_RESULTS.SUCCESS:
      return { ...state, partnerSearchResults: action.response }
    default:
      return state
  }
}



/** WEBPACK FOOTER **
 ** ./src/reducers/settings/settings.js
 **/